import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'

// Get metadata about the Foreplay API (version, etc.)
const getAPIInfo = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get('public-api/api', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

// Get a user's Foreplay API Key
const getAPIKey = async () => {
  // Pull the needed information off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get('public-api/api/api-key/get', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

// Generate an API key for the user
const createAPIKey = async () => {
  // Pull the needed information off the user
  const { Aa: token, email } = firebase.auth().currentUser

  // Make sure the user doesn't already have an API key
  if (await getAPIKey()) {
    throw new Error('API key already exists for this user')
  }

  const payload = {
    email,
    plan: 'pro', // TODO: NEED TO FIGURE OUT PLAN/PRICING
    total_credits: 50000, // TODO: NEED TO FIGURE OUT PLAN/PRICING
    credit_window_days: 30,
    status: 1
  }

  const { data } = await AxiosConfig.post(
    'public-api/api/api-key/create',
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  const newKey = data?.data?.api_key
  if (!newKey) {
    throw new Error('Failed to create API key')
  }

  return newKey
}

// Refresh a user's API key
const refreshAPIKey = async () => {
  // Pull the needed information off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.put(
    'public-api/api/api-key/update',
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
  )

  const newKey = data?.data?.new_api_key
  if (!newKey) {
    throw new Error('Failed to refresh API key. Response did not contain new key.')
  }

  return newKey
}

// Get usage history for a user or team
const getUsageHistory = async (pagination, parameters, filters, teamId = null) => {
  const { Aa: token, uid } = firebase.auth().currentUser

  const params = {
    user_or_team_id: teamId ?? uid,
    ...pagination,
    ...parameters,
    ...filters
  }

  const { data } = await AxiosConfig.get('public-api/api/logs/usages', {
    params,
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

// Get logs for a user or team
const getLogs = async (pagination, filters, teamId = null) => {
  // Pull the current token off the user
  const { Aa: token, uid } = firebase.auth().currentUser

  const params = {
    user_or_team_id: teamId ?? uid,
    ...pagination,
    ...filters
  }

  const { data } = await AxiosConfig.get('public-api/api/logs/operations', {
    params,
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  // Has data and metadata properties
  return data
}

// Get details for a request using the traceId
const getRequestDetails = async (traceId) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(`public-api/api/logs/trace/${traceId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

export default {
  getAPIInfo,
  getAPIKey,
  createAPIKey,
  refreshAPIKey,
  getUsageHistory,
  getLogs,
  getRequestDetails
}